import { Link, useLocation } from 'react-router-dom';
import { Breadcrumb } from 'react-bootstrap';

interface BreadcrumbsProps {
  selectedGroupId?: string | null;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ selectedGroupId }) => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(Boolean);
  const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  const breadcrumbNames: Record<string, string> = {
    '': 'Home',
    home: 'Home',
    oob: 'OOB',
    admin: 'Admin',
    'my-groups': 'My Groups',
    group: 'Group',
    'sharepoint-lists': 'SharePoint Lists',
    'saved-data': 'Saved Data',
    'my-activity-log': 'My Activity Log',
    'physical-records': 'Physical Records',
  };

  return (
    <Breadcrumb className="mb-3" 
      style={{
          paddingLeft: "20px"
        }}>
      <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
        Home
      </Breadcrumb.Item>
      {pathnames.map((value, index) => {
        const isLast = index === pathnames.length - 1;
        const to = `/${pathnames.slice(0, index + 1).join('/')}`;
        const previousSegment = index > 0 ? pathnames[index - 1] : "";
        const displayName =
          (previousSegment === "physical-records" && /^(?:\d+|[BF]\d+)$/i.test(value))
            ? `Record ${value}`
            : (previousSegment === "oob" && guidPattern.test(value))
            ? "Event"
            : breadcrumbNames[value] || value.charAt(0).toUpperCase() + value.slice(1);

        return isLast ? (
          <Breadcrumb.Item key={to} active>
            {displayName}
          </Breadcrumb.Item>
        ) : (
          <Breadcrumb.Item key={to} linkAs={Link} linkProps={{ to }}>
            {displayName}
          </Breadcrumb.Item>
        );
      })}
      {selectedGroupId && (
        <Breadcrumb.Item active>{`Group ${selectedGroupId}`}</Breadcrumb.Item>
      )}
    </Breadcrumb>
  );
};

export default Breadcrumbs;